import { Promise } from 'es6-promise';

import { PM } from '../../constants';
import { pmRequest } from './requestFactory';
import FSA from '../FSA';

interface ISystemJobs {
    nodeId?: string
}

interface IParams {
    containerIds: string[],
    start: Date,
    end: Date,
}

function fetchJobs(requesterId: string, params: IParams): Promise<ISystemJobs[]> {
    const { containerIds, start, end } = params;

    const query = {
        ContainerIdList: containerIds.map((id) => {
            return {
                ContainerId: id
            };
        }),
        From: start.toISOString(),
        To: end.toISOString(),
    };

    return pmRequest.post(`container/history/get`, query).then((jobs) => {
        return jobs.reduce((r, cJobs) => {
            r[cJobs.ContainerId] = cJobs.JobList;
            return r;
        }, {});
    });
}

function listJobs(requesterId: string, params: IParams): Function {
    return dispatch => {
        dispatch(new FSA(PM.FETCH_JOBS_REQUEST).addMeta({ requesterId }).data);

        return fetchJobs(requesterId, params).then((jobs: any[]) => {
            return dispatch(new FSA(PM.FETCH_JOBS_SUCCESS).addPayload(jobs).addMeta({ requesterId }).data);
        }, err => {
            dispatch(new FSA(PM.FETCH_JOBS_FAILURE).addError(err).addMeta({ requesterId }).data);
            throw err;
        });
    }
}

export {
    ISystemJobs,
    fetchJobs,
    listJobs,
};


// WEBPACK FOOTER //
// ./src/actions/pm/Job.ts